export default "__VITE_ASSET__i$kjaBl4__"